import { Controller } from '@hotwired/stimulus';
import { onDomReady } from '../utilities/browser';

export default class extends Controller {
    static targets = ['filters', 'list', 'clear', 'count', 'childrenList', 'grandchildrenList', 'panel', 'toggle', 'content'];

    connect() {
        super.connect();
        this.updateURLTimeout = null;
        this.filterTimeout = null;
        if (this.hasFiltersTarget) {

            const range = this.element.querySelector('#ageRange');
            const valueEl = this.element.querySelector('[data-sidebar-filter-target="ageValue"]');
            const hidden = this.element.querySelector('#ageHidden');
            let interacted = false;

            if (range && valueEl) {
                const THUMB_W = 18;
                const update = () => {
                    const min = parseInt(range.min || '0');
                    const max = parseInt(range.max || '99');
                    const val = parseInt(range.value || '0');

                    const rect = range.getBoundingClientRect();
                    const trackW = rect.width;

                    const ratio = (val - min) / (max - min || 1);
                    const posPx = ratio * (trackW - THUMB_W) + (THUMB_W / 2);

                    range.style.backgroundSize = `${posPx}px 100%`;
                    valueEl.style.left = `${posPx}px`;
                    if (val === 0) {
                        valueEl.textContent = 'Visi';
                        if (hidden) hidden.value = '';
                    } else {
                        valueEl.textContent = String(val);
                        if (interacted && hidden) hidden.value = String(val);
                    }
                };

                update();
                range.addEventListener('input', () => {
                    interacted = true;
                    update();
                    this.debouncedFilterAndURL();
                });
                window.addEventListener('resize', update);
            }
            if (window.location.search) {
                this.applyFiltersFromURL();
            }

            this.filtersTarget.addEventListener('input', () => {
                this.debouncedFilterAndURL();
            });
            // Clear button behaviour – resets form, URL and rerenders cards
            if (this.hasClearTarget) {
                this.clearTarget.addEventListener('click', (e) => {
                    e.preventDefault();
                    // Reset form values
                    this.filtersTarget.reset();
                    // Ensure disabled checkboxes remain unchecked after reset
                    this.filtersTarget.querySelectorAll('input[type="checkbox"]:disabled').forEach(input => {
                        input.checked = false;
                    });

                    const allSelects = this.filtersTarget.querySelectorAll('select');
                    allSelects.forEach(select => {
                        if (select.tomselect) {
                            select.tomselect.setValue('', true);
                        } else {
                            select.value = '';
                        }
                    });
                    const keywordInput = this.filtersTarget.querySelector('input[name="keyword"]');
                    if (keywordInput) {
                        keywordInput.value = '';
                    }

                    const range = this.element.querySelector('#ageRange');
                    const valueEl = this.element.querySelector('[data-sidebar-filter-target="ageValue"]');
                    const hidden = this.element.querySelector('#ageHidden');
                    if (range && valueEl) {
                         // Reset to 0 (no filter)
                         range.value = '0';
                         if (hidden) hidden.value = '';
                         const min = 0;
                         const max = 99;
                         const val = 0;
                         const rect = range.getBoundingClientRect();
                         const trackW = rect.width;
                         const THUMB_W = 18;
                         const ratio = (val - min) / (max - min || 1);
                         const posPx = ratio * (trackW - THUMB_W) + (THUMB_W / 2);
                         range.style.backgroundSize = `${posPx}px 100%`;
                         valueEl.style.left = `${posPx}px`;
                         valueEl.textContent = 'Visi';
                     }
                    // clean URL query
                    window.history.pushState({}, '', window.location.pathname);
                    // apply filters
                    this.filter();
                });
            }

            this.filter();
        }


        this.clearClass = this.element.dataset.clearClass || 'd-none';

        // Initialize mobile toggle functionality
        this.initMobileToggle();
    }



    filter() {
        if (!this.hasFiltersTarget) {
            return;
        }
        
        const filters = Array.from(new FormData(this.filtersTarget).entries())
            .filter(([key, value]) => {
                // Skip age range UI input - we only want the hidden 'age' field
                if (key === 'age_range_ui') return false;

                // Skip empty values
                if (!value || String(value).length === 0) return false;
          
                // For age field, also check if it's "0" which means "all ages"
                if (key === 'age' && value === '0') return false;

                // Skip disabled checkboxes
                const input = this.filtersTarget.querySelector(`[name="${key}"][value="${value}"], [name="${key}[]"][value="${value}"]`);
                if (input && input.disabled) return false;

                return true;
            });



        if (this.hasGrandchildrenListTarget) {
            const hasAgeFilter = filters.some(([key, value]) => key === 'age' && value && value.length > 0);
            
            if (filters.length > 0 || hasAgeFilter) {
                this.childrenListTarget.classList.add('d-none');
                this.grandchildrenListTarget.classList.remove('d-none');

                const cards = Array.from(this.grandchildrenListTarget.children);
                let matched = cards;

                // Clear button is always visible now
                // if (this.hasClearTarget) {
                //     if (this.clearTarget.hasAttribute('data-hide-parent')) {
                //         this.clearTarget.parentElement.classList.remove(this.clearClass);
                //     } else {
                //         this.clearTarget.classList.remove(this.clearClass);
                //     }
                // }

                for (let [key, value] of filters) {
                    matched = matched.filter(card => {
                        const attr = `data-filter-${key.replace('[]', '').replace(/_/g, '-')}`;

                        if (key === 'keyword') {
                            const normalizeText = (text) => {
                                return text
                                    .toLowerCase()
                                    .replace(/ą/g, 'a')
                                    .replace(/č/g, 'c')
                                    .replace(/ę/g, 'e')
                                    .replace(/ė/g, 'e')
                                    .replace(/į/g, 'i')
                                    .replace(/š/g, 's')
                                    .replace(/ų/g, 'u')
                                    .replace(/ū/g, 'u')
                                    .replace(/ž/g, 'z');
                            };
                            const keywordAttr = normalizeText(card.getAttribute('data-filter-keyword') || '');
                            const searchValue = normalizeText(value);
                            return keywordAttr.includes(searchValue);
                        }

                        if (key === 'age') {
                            let ageRangesString = card.getAttribute('data-filter-page-age-groups') || card.getAttribute('data-filter-age');

                            if (!ageRangesString || ageRangesString === '') {
                                return false;
                            }

                            if (value.includes('-')) {
                                const [searchMinAge, searchMaxAge] = value.split('-').map(age => parseInt(age.trim()));
                                const rangeSegments = ageRangesString.split(',');

                                return rangeSegments.some(segment => {
                                    segment = segment.trim();
                                    if (segment.includes('-')) {
                                        const [cardMinAge, cardMaxAge] = segment.split('-').map(age => parseInt(age.trim()));
                                        return (searchMinAge <= cardMaxAge && searchMaxAge >= cardMinAge);
                                    } else {
                                        const cardAge = parseInt(segment);
                                        return (searchMinAge <= cardAge && searchMaxAge >= cardAge);
                                    }
                                });
                            } else {
                                const selectedAge = parseInt(value);
                                const rangeSegments = ageRangesString.split(',');

                                return rangeSegments.some(segment => {
                                    segment = segment.trim();
                                    if (segment.includes('-')) {
                                        const [minAge, maxAge] = segment.split('-').map(age => parseInt(age.trim()));
                                        return selectedAge >= minAge && selectedAge <= maxAge;
                                    } else {
                                        const age = parseInt(segment);
                                        return selectedAge === age;
                                    }
                                });
                            }
                        }

                        const filterValues = (card.getAttribute(attr) || '').split(',').filter(Boolean);
                        return filterValues.includes(value);
                    });
                }

                for (let card of cards) {
                    if (matched.includes(card)) {
                        card.classList.remove('d-none');
                    } else {
                        card.classList.add('d-none');
                    }
                }

                if (this.hasCountTarget) {
                    this.countTarget.innerHTML = matched.length;
                }
            } else {
                // Show children and hide grandchildren when no filters
                if (this.childrenListTarget.children.length > 0) {
                    this.childrenListTarget.classList.remove('d-none');
                    this.grandchildrenListTarget.classList.add('d-none');
                } else {
                    this.childrenListTarget.classList.add('d-none');
                    this.grandchildrenListTarget.classList.remove('d-none');
                    const cards = Array.from(this.grandchildrenListTarget.children);
                    cards.forEach(card => card.classList.remove('d-none'));
                }

                // Clear button is always visible now
                // if (this.hasClearTarget) {
                //     if (this.clearTarget.hasAttribute('data-hide-parent')) {
                //         this.clearTarget.parentElement.classList.add(this.clearClass);
                //     } else {
                //         this.clearTarget.classList.add(this.clearClass);
                //     }
                // }

                if (this.hasCountTarget) {
                    if (this.childrenListTarget.children.length > 0) {
                        this.countTarget.innerHTML = this.childrenListTarget.children.length;
                    } else {
                        this.countTarget.innerHTML = this.grandchildrenListTarget.children.length;
                    }
                }
            }
        } else {
            // Use childrenList if available, otherwise fallback to list
            const targetContainer = this.hasChildrenListTarget ? this.childrenListTarget : this.listTarget;
            const cards = Array.from(targetContainer.children);
            let matched = cards;

            if (filters.length) {
                // Clear button is always visible now
                // if (this.clearTarget.hasAttribute('data-hide-parent')) {
                //     this.clearTarget.parentElement.classList.remove(this.clearClass);
                // } else {
                //     this.clearTarget.classList.remove(this.clearClass);
                // }

                for (let [key, value] of filters) {
                    matched = matched.filter(card => {
                        const attr = `data-filter-${key.replace('[]', '').replace(/_/g, '-')}`;

                        if (key === 'age' || key === 'page_age_groups') {
                            let ageRangesString = card.getAttribute('data-filter-page-age-groups') || card.getAttribute('data-filter-age');

                            if (!ageRangesString || ageRangesString === '') {
                                return false;
                            }

                            if (value.includes('-')) {
                                const [searchMinAge, searchMaxAge] = value.split('-').map(age => parseInt(age.trim()));
                                const rangeSegments = ageRangesString.split(',');
                                
                                return rangeSegments.some(segment => {
                                    segment = segment.trim();
                                    if (segment.includes('-')) {
                                        const [bureauMinAge, bureauMaxAge] = segment.split('-').map(age => parseInt(age.trim()));
                                        return (searchMinAge <= bureauMaxAge && searchMaxAge >= bureauMinAge);
                                    } else {
                                        const bureauAge = parseInt(segment);
                                        return (searchMinAge <= bureauAge && searchMaxAge >= bureauAge);
                                    }
                                });
                            } else {
                                const searchAge = parseInt(value);
                                const rangeSegments = ageRangesString.split(',');
                                
                                return rangeSegments.some(segment => {
                                    segment = segment.trim();
                                    if (segment.includes('-')) {
                                        const [minAge, maxAge] = segment.split('-').map(age => parseInt(age.trim()));
                                        return searchAge >= minAge && searchAge <= maxAge;
                                    } else {
                                        const age = parseInt(segment);
                                        return searchAge === age;
                                    }
                                });
                            }
                        }

                        if (key === 'available') {
                            const availableValue = card.getAttribute('data-filter-available') || '';
                            
                            if (value === 'all') {
                                return true;
                            }
                            return availableValue === value;
                        }
                        if (key === 'instructor') {
                            const cardInstructor = card.getAttribute('data-filter-instructor') || '';
                            return cardInstructor === value;
                        }

                        const filterValues = (card.getAttribute(attr) || '').split(',').filter(Boolean);
                        return filterValues.includes(value);
                    });
                }
            } else {
                // Clear button is always visible now
                // if (this.clearTarget.hasAttribute('data-hide-parent')) {
                //     this.clearTarget.parentElement.classList.add(this.clearClass);
                // } else {
                //     this.clearTarget.classList.add(this.clearClass);
                // }
            }

            for (let card of cards) {
                if (matched.includes(card)) {
                    card.classList.remove('d-none');
                } else {
                    card.classList.add('d-none');
                }
            }

            if (this.hasCountTarget) {
                this.countTarget.innerHTML = matched.length;
            }
        }
    }

    applyFiltersFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const form = this.filtersTarget;

        form.reset();

        for (const [key, value] of urlParams.entries()) {
            const keyBase = key.replace('[]', '');
            const elements = form.querySelectorAll(`[name="${keyBase}[]"], [name="${keyBase}"]`);

            elements.forEach(element => {
                if (element.type === 'checkbox') {
                    element.checked = element.value === value;
                } else if (element.type === 'radio') {
                    element.checked = element.value === value;
                } else if (element.tagName === 'SELECT') {
                    element.value = value;
                } else if (element.type === 'text') {
                    element.value = value;
                } else {
                    element.value = value;
                }
            });
        }
        const ageParam = urlParams.get('age');
        if (ageParam) {
            const ageHidden = form.querySelector('#ageHidden');
            const ageRange = form.querySelector('#ageRange');
            const ageValue = form.querySelector('[data-sidebar-filter-target="ageValue"]');
            
            if (ageParam.includes('-')) {
                const [minAge, maxAge] = ageParam.split('-').map(a => parseInt(a.trim()));
                if (ageHidden) ageHidden.value = ageParam;
                if (ageRange) {
                    ageRange.value = maxAge;
                    const min = parseInt(ageRange.min || '0');
                    const max = parseInt(ageRange.max || '99');
                    const ratio = (maxAge - min) / (max - min || 1);
                    const rect = ageRange.getBoundingClientRect();
                    const trackW = rect.width || 300;
                    const THUMB_W = 18;
                    const posPx = ratio * (trackW - THUMB_W) + (THUMB_W / 2);
                    ageRange.style.backgroundSize = `${posPx}px 100%`;
                    if (ageValue) {
                        ageValue.style.left = `${posPx}px`;
                        ageValue.textContent = maxAge === 0 ? 'Visi' : String(maxAge);
                    }
                }
            } else {
                const age = parseInt(ageParam);
                if (ageHidden) ageHidden.value = ageParam;
                if (ageRange) {
                    ageRange.value = age;
                    const min = parseInt(ageRange.min || '0');
                    const max = parseInt(ageRange.max || '99');
                    const ratio = (age - min) / (max - min || 1);
                    const rect = ageRange.getBoundingClientRect();
                    const trackW = rect.width || 300;
                    const THUMB_W = 18;
                    const posPx = ratio * (trackW - THUMB_W) + (THUMB_W / 2);
                    ageRange.style.backgroundSize = `${posPx}px 100%`;
                    if (ageValue) {
                        ageValue.style.left = `${posPx}px`;
                        ageValue.textContent = age === 0 ? 'Visi' : String(age);
                    }
                }
            }
        }
        this.filter();
    }

    debouncedUpdateURL() {
        if (this.updateURLTimeout) {
            clearTimeout(this.updateURLTimeout);
        }
        this.updateURLTimeout = setTimeout(() => {
            this.updateURL();
        }, 500);
    }

    debouncedFilterAndURL() {
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }
        this.filterTimeout = setTimeout(() => {
            this.filter();
            this.updateURL();
        }, 500);
    }

    updateURL() {
        const filters = new FormData(this.filtersTarget);
        const urlParams = new URLSearchParams();

        const paramGroups = {};
        for (const [key, value] of filters.entries()) {
            if (value.length > 0) {
                const baseKey = key.replace('[]', '');
                if (!paramGroups[baseKey]) {
                    paramGroups[baseKey] = [];
                }
                paramGroups[baseKey].push(value);
            }
        }

        for (const [key, values] of Object.entries(paramGroups)) {
            values.forEach(value => {
                if (key === 'keyword' || key === 'age' || key === 'age_range_ui') {
                    urlParams.append(key, value);
                } else {
                    urlParams.append(`${key}[]`, value);
                }
            });
        }

        const newURL = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '');
        window.history.pushState({}, '', newURL);
    }

    initMobileToggle() {
        // Setup mobile media query
        this.mq = window.matchMedia('(max-width: 480px)');

        // Find the panel and toggle elements
        const panel = this.hasPanelTarget ? this.panelTarget : this.element.querySelector('.filter-panel-redesign');
        const toggle = this.hasToggleTarget ? this.toggleTarget : this.element.querySelector('.filter-toggle');
        const header = this.element.querySelector('.filter-header');

        if (!panel || !toggle) return;

        // Set up toggle functionality
        const handleToggle = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isMobile = this.mq.matches;
            if (!isMobile) return;

            panel.classList.toggle('collapsed');
            const isCollapsed = panel.classList.contains('collapsed');
            toggle.setAttribute('aria-expanded', !isCollapsed);
        };

        // Add click listeners
        toggle.addEventListener('click', handleToggle);
        if (header) {
            header.addEventListener('click', handleToggle);
        }

        // Handle responsive changes
        const handleResize = () => {
            const isMobile = this.mq.matches;

            if (isMobile) {
                // On mobile, start collapsed
                panel.classList.add('collapsed');
                toggle.setAttribute('aria-expanded', 'false');
            } else {
                // On desktop, always expanded
                panel.classList.remove('collapsed');
                toggle.setAttribute('aria-expanded', 'true');
            }
        };

        // Initial setup and listen for changes
        handleResize();
        this.mq.addEventListener('change', handleResize);
        window.addEventListener('resize', handleResize);
    }
}
